// extracted by mini-css-extract-plugin
module.exports = {"pillList":"styles__pillList___1h7UH","pill":"styles__pill___2EjaW"};